/**
 * @generated SignedSource<<cba8afeb86e016b9b8fa3044a1779c4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly label: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly form: {
    readonly " $fragmentSpreads": FragmentRefs<"ContactForm_contactForm">;
  };
  readonly id: string;
  readonly path: string | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "ContactPage_page";
};
export type ContactPage_page$key = {
  readonly " $data"?: ContactPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactPage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactForm",
      "kind": "LinkedField",
      "name": "form",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContactForm_contactForm"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContactPage",
  "abstractKey": null
};

(node as any).hash = "b39be4c37f3cc617e99fdb39c4024522";

export default node;
